const actions = {
  SET_STATE: 'billingHistory/SET_STATE',
  CLEAR_STATE: 'billingHistory/CLEAR_STATE',
  GET_BILLING_HISTORY: 'billingHistory/GET_BILLING_HISTORY',
  DOWNLOAD_INVOICE: 'billingHistory/DOWNLOAD_INVOICE',
}

export default actions
